import React from 'react';
import { Avatar as DefaultAvatar } from '../Avatar';
import { ChatDown } from '../ChatDown/ChatDown';
import { LoadingChannels } from '../Loading/LoadingChannels';
import chevrondown from '../../assets/str-chat__icon-chevron-down.svg';
import { useChatContext } from '../../context/ChatContext';
/**
 *  @deprecated - This UI component will be removed in the next major release.
 *
 * A preview list of channels, allowing you to select the channel you want to open
 */
export var ChannelListTeam = function (props) {
    var _a = props.Avatar, Avatar = _a === void 0 ? DefaultAvatar : _a, children = props.children, _b = props.error, error = _b === void 0 ? false : _b, loading = props.loading, _c = props.LoadingErrorIndicator, LoadingErrorIndicator = _c === void 0 ? ChatDown : _c, _d = props.LoadingIndicator, LoadingIndicator = _d === void 0 ? LoadingChannels : _d, showSidebar = props.showSidebar, sidebarImage = props.sidebarImage;
    var client = useChatContext().client;
    var _e = client.user || {}, id = _e.id, image = _e.image, name = _e.name, status = _e.status;
    if (error) {
        return React.createElement(LoadingErrorIndicator, { type: 'Connection Error' });
    }
    if (loading) {
        return React.createElement(LoadingIndicator, null);
    }
    return (React.createElement("div", { className: 'str-chat__channel-list-team' },
        showSidebar && (React.createElement("div", { className: 'str-chat__channel-list-team__sidebar' },
            React.createElement("div", { className: 'str-chat__channel-list-team__sidebar--top' },
                React.createElement(Avatar, { image: sidebarImage, size: 50 })))),
        React.createElement("div", { className: 'str-chat__channel-list-team__main' },
            React.createElement("div", { className: 'str-chat__channel-list-team__header' },
                React.createElement("div", { className: 'str-chat__channel-list-team__header--left' },
                    React.createElement(Avatar, { image: image, name: name || id, size: 40 })),
                React.createElement("div", { className: 'str-chat__channel-list-team__header--middle' },
                    React.createElement("div", { className: 'str-chat__channel-list-team__header--title' }, name || id),
                    React.createElement("div", { className: "str-chat__channel-list-team__header--status " + status }, status)),
                React.createElement("div", { className: 'str-chat__channel-list-team__header--right' },
                    React.createElement("button", { className: 'str-chat__channel-list-team__header--button' },
                        React.createElement("img", { src: chevrondown })))),
            children)));
};
